import type { TranslationTable } from "@repo/shared/types";

const EN_GB = {
  verifiedId: "Verified ID",
  verifiedIdDescription: "All clients",
  notVerified: "not verified",
  verifiedCount: (n: string) => `${n} verified`,
  notVerifiedCount: (n: string) => `${n} not verified`,
  openClientsReview: "Open clients review",
  clientCount: (n: string) => `${n} clients`,
};

// All 17 locales (QL-17 plan keeps them); the type makes each one match EN_GB.
export const T: TranslationTable<typeof EN_GB> = {
  en_GB: EN_GB,
  fr_FR: {
    verifiedId: "Identité vérifiée",
    verifiedIdDescription: "Tous les clients",
    notVerified: "non vérifiés",
    verifiedCount: (n) => `${n} vérifiés`,
    notVerifiedCount: (n) => `${n} non vérifiés`,
    openClientsReview: "Ouvrir la revue des clients",
    clientCount: (n) => `${n} clients`,
  },
  es_ES: {
    verifiedId: "Identidad verificada",
    verifiedIdDescription: "Todos los clientes",
    notVerified: "sin verificar",
    verifiedCount: (n) => `${n} verificados`,
    notVerifiedCount: (n) => `${n} sin verificar`,
    openClientsReview: "Abrir revisión de clientes",
    clientCount: (n) => `${n} clientes`,
  },
  pt_BR: {
    verifiedId: "Identidade verificada",
    verifiedIdDescription: "Todos os clientes",
    notVerified: "não verificados",
    verifiedCount: (n) => `${n} verificados`,
    notVerifiedCount: (n) => `${n} não verificados`,
    openClientsReview: "Abrir revisão de clientes",
    clientCount: (n) => `${n} clientes`,
  },
  de_DE: {
    verifiedId: "Verifizierte Identität",
    verifiedIdDescription: "Alle Kunden",
    notVerified: "nicht verifiziert",
    verifiedCount: (n) => `${n} verifiziert`,
    notVerifiedCount: (n) => `${n} nicht verifiziert`,
    openClientsReview: "Kundenprüfung öffnen",
    clientCount: (n) => `${n} Kunden`,
  },
  it_IT: {
    verifiedId: "Identità verificata",
    verifiedIdDescription: "Tutti i clienti",
    notVerified: "non verificati",
    verifiedCount: (n) => `${n} verificati`,
    notVerifiedCount: (n) => `${n} non verificati`,
    openClientsReview: "Apri revisione clienti",
    clientCount: (n) => `${n} clienti`,
  },
  ar: {
    verifiedId: "هوية موثّقة",
    verifiedIdDescription: "جميع العملاء",
    notVerified: "غير موثّقة",
    verifiedCount: (n) => `${n} موثّقة`,
    notVerifiedCount: (n) => `${n} غير موثّقة`,
    openClientsReview: "فتح مراجعة العملاء",
    clientCount: (n) => `${n} عملاء`,
  },
  ja_JP: {
    verifiedId: "本人確認",
    verifiedIdDescription: "全顧客",
    notVerified: "未確認",
    verifiedCount: (n) => `確認済み ${n} 名`,
    notVerifiedCount: (n) => `未確認 ${n} 名`,
    openClientsReview: "顧客レビューを開く",
    clientCount: (n) => `顧客 ${n} 名`,
  },
  hi_IN: {
    verifiedId: "सत्यापित पहचान",
    verifiedIdDescription: "सभी क्लाइंट",
    notVerified: "सत्यापित नहीं",
    verifiedCount: (n) => `${n} सत्यापित`,
    notVerifiedCount: (n) => `${n} सत्यापित नहीं`,
    openClientsReview: "क्लाइंट समीक्षा खोलें",
    clientCount: (n) => `${n} क्लाइंट`,
  },
  zh_CN: {
    verifiedId: "已验证身份",
    verifiedIdDescription: "全部客户",
    notVerified: "未验证",
    verifiedCount: (n) => `${n} 位已验证`,
    notVerifiedCount: (n) => `${n} 位未验证`,
    openClientsReview: "打开客户审核",
    clientCount: (n) => `${n} 位客户`,
  },
  zh_TW: {
    verifiedId: "已驗證身分",
    verifiedIdDescription: "所有客戶",
    notVerified: "未驗證",
    verifiedCount: (n) => `${n} 位已驗證`,
    notVerifiedCount: (n) => `${n} 位未驗證`,
    openClientsReview: "開啟客戶審核",
    clientCount: (n) => `${n} 位客戶`,
  },
  nl_NL: {
    verifiedId: "Geverifieerde identiteit",
    verifiedIdDescription: "Alle klanten",
    notVerified: "niet geverifieerd",
    verifiedCount: (n) => `${n} geverifieerd`,
    notVerifiedCount: (n) => `${n} niet geverifieerd`,
    openClientsReview: "Klantbeoordeling openen",
    clientCount: (n) => `${n} klanten`,
  },
  nb_NO: {
    verifiedId: "Verifisert ID",
    verifiedIdDescription: "Alle kunder",
    notVerified: "ikke verifisert",
    verifiedCount: (n) => `${n} verifisert`,
    notVerifiedCount: (n) => `${n} ikke verifisert`,
    openClientsReview: "Åpne kundegjennomgang",
    clientCount: (n) => `${n} kunder`,
  },
  sv_SE: {
    verifiedId: "Verifierat ID",
    verifiedIdDescription: "Alla kunder",
    notVerified: "ej verifierade",
    verifiedCount: (n) => `${n} verifierade`,
    notVerifiedCount: (n) => `${n} ej verifierade`,
    openClientsReview: "Öppna kundgranskning",
    clientCount: (n) => `${n} kunder`,
  },
  fi_FI: {
    verifiedId: "Vahvistettu henkilöllisyys",
    verifiedIdDescription: "Kaikki asiakkaat",
    notVerified: "ei vahvistettu",
    verifiedCount: (n) => `${n} vahvistettu`,
    notVerifiedCount: (n) => `${n} ei vahvistettu`,
    openClientsReview: "Avaa asiakkaiden tarkastus",
    clientCount: (n) => `${n} asiakasta`,
  },
  da_DK: {
    verifiedId: "Verificeret ID",
    verifiedIdDescription: "Alle kunder",
    notVerified: "ikke verificeret",
    verifiedCount: (n) => `${n} verificeret`,
    notVerifiedCount: (n) => `${n} ikke verificeret`,
    openClientsReview: "Åbn kundegennemgang",
    clientCount: (n) => `${n} kunder`,
  },
  is_IS: {
    verifiedId: "Staðfest auðkenni",
    verifiedIdDescription: "Allir viðskiptavinir",
    notVerified: "óstaðfest",
    verifiedCount: (n) => `${n} staðfest`,
    notVerifiedCount: (n) => `${n} óstaðfest`,
    openClientsReview: "Opna yfirferð viðskiptavina",
    clientCount: (n) => `${n} viðskiptavinir`,
  },
};
